export default "assets/images/cnil-rgpd-black-9fc88935.png";